module.exports = "/_next/static/images/b51a2b2349c3fa2b2c43406108726d28-pen@desktop1366.jpg";